import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DashboardModalActions, ImageNext } from '@carvana/purchase-helpers';
import { ScheduleType } from '@carvana/purchase-utils';
import {
  CongratsModalDuoCheck,
  CongratsModalPhone,
  CongratsModalAccidentFree
} from '@carvana/purchase-icons/src';
import moment from 'moment';
import * as sc from './congratulations-modal.styles';

const CongratulationsModal = props => {
  const {
    vehicle: { year, make, model, isMarketplaceVehicle, srcImageUrl },
    orderSummary: {
      schedule: { scheduleStartDateTimeUtc, deliveryPreference }
    }
  } = props;
  const yearMakeModelText = `${year} ${make} ${model}`;

  const [twoDaysOrLessUntilDelivery, setTwoDaysOrLessUntilDelivery] = useState(
    false
  );
  const [deliveryDateText, setDeliveryDateText] = useState('');
  const [deliveryType, setDeliveryType] = useState('');

  const getDeliveryType = () => {
    let deliveryTypeText;

    const scheduleType = ScheduleType(deliveryPreference);

    if (scheduleType.isDelivery) {
      deliveryTypeText = 'delivery';
    } else if (scheduleType.isPickup) {
      deliveryTypeText = 'pickup';
    }

    setDeliveryType(deliveryTypeText);
  };

  const getTwoDaysOrLessUntilDelivery = () => {
    const deliveryDate = moment(scheduleStartDateTimeUtc)
      .local()
      .startOf('day');

    const currentDate = moment().startOf('day');

    const daysUntilDelivery = deliveryDate.diff(currentDate, 'days');

    let twoDaysUntilDelivery;

    if (daysUntilDelivery <= 2) {
      twoDaysUntilDelivery = true;
    } else {
      twoDaysUntilDelivery = false;
    }
    setTwoDaysOrLessUntilDelivery(twoDaysUntilDelivery);

    let deliveryDateTextString;

    if (daysUntilDelivery === 0) {
      deliveryDateTextString = 'today';
    } else if (daysUntilDelivery === 1) {
      deliveryDateTextString = 'tomorrow';
    } else if (daysUntilDelivery === 2) {
      deliveryDateTextString = 'the day after tomorrow';
    }

    setDeliveryDateText(deliveryDateTextString);
  };

  useEffect(() => {
    getTwoDaysOrLessUntilDelivery();
  }, []);

  useEffect(() => {
    getDeliveryType();
  }, []);

  return (
    <sc.ContentWrapper>
      <sc.ImageContainer>
        <ImageNext alt={`${yearMakeModelText}`} src={srcImageUrl} />
      </sc.ImageContainer>
      <sc.TextWrapper>
        <sc.BoldText>Thank you for your order!</sc.BoldText>
        <sc.BoldTextSmall>WHAT&apos;S NEXT?</sc.BoldTextSmall>

        {!twoDaysOrLessUntilDelivery && (
          <sc.IconAndTextWrapper>
            <sc.CheckmarkIconWrapper src={CongratsModalDuoCheck} />
            <sc.CheckmarkBodyText>
              We&apos;re verifying your information and documents. This usually
              takes 1-2 days.
            </sc.CheckmarkBodyText>
          </sc.IconAndTextWrapper>
        )}

        {twoDaysOrLessUntilDelivery && deliveryPreference === 'DirectDelivery' && (
          <sc.IconAndTextWrapper>
            <sc.CheckmarkIconWrapper src={CongratsModalDuoCheck} />
            <sc.CheckmarkBodyText>
              We&apos;re verifying your information and documents. This usually
              takes 1-2 days.
            </sc.CheckmarkBodyText>
          </sc.IconAndTextWrapper>
        )}

        {twoDaysOrLessUntilDelivery && deliveryPreference !== 'DirectDelivery' && (
          <sc.IconAndTextWrapper>
            <sc.CheckmarkIconWrapper src={CongratsModalDuoCheck} />
            <sc.CheckmarkBodyText>
              We&apos;re verifying your information and documents. Because your{' '}
              {deliveryType} is {deliveryDateText}, we&apos;re prioritizing your
              order for speedy review.
            </sc.CheckmarkBodyText>
          </sc.IconAndTextWrapper>
        )}

        <sc.IconAndTextWrapper>
          <sc.IconWrapper src={CongratsModalPhone} />
          <sc.BodyText>
            <b>Watch your texts and email.</b> We may need additional
            information or documents.
          </sc.BodyText>
        </sc.IconAndTextWrapper>

        {isMarketplaceVehicle && (
          <sc.IconAndTextWrapper>
            <sc.CarIconWrapper src={CongratsModalAccidentFree} />
            <sc.CarBodyText>
              We&apos;ll confirm the vehicle&apos;s availability as soon as your
              order is verified.
            </sc.CarBodyText>
          </sc.IconAndTextWrapper>
        )}
      </sc.TextWrapper>
      <sc.ButtonWrapper>
        <sc.CancelButton onClick={DashboardModalActions.CloseModal}>
          Got it
        </sc.CancelButton>
      </sc.ButtonWrapper>
    </sc.ContentWrapper>
  );
};

CongratulationsModal.propTypes = {
  vehicle: PropTypes.shape({}).isRequired,
  orderSummary: PropTypes.shape({}).isRequired,
};

CongratulationsModal.defaultProps = {
};

export default CongratulationsModal;
